var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner__dot spinner__dot--bounce1",style:(_vm.getDotsStyle())}),_c('div',{staticClass:"spinner__dot spinner__dot--bounce2",style:(_vm.getDotsStyle())}),_c('div',{staticClass:"spinner__dot spinner__dot--bounce3",style:(_vm.getDotsStyle())})])])
}
var staticRenderFns = []

export { render, staticRenderFns }